import { default as RDatePicker } from 'react-datepicker'

import styled from '@emotion/styled'

import { TIME_INTERVAL } from './utils'

const StyledDatePicker = styled(RDatePicker)`
  width: 100%;
  font-weight: 600;
  font-size: 14px;
  color: ${(p) => (p.disabled ? 'rgba(0,0,0,0.5)' : '#000')};
  border: 2px solid
    ${(p) => (p.valid ? '#2BD2B4' : p.isInvalid ? '#D01030' : '#9FB8E5')};
  min-height: 48px;
  border-radius: 6px;
  padding-inline-start: 16px;
  padding-inline-end: 16px;

  ::placeholder {
    font-size: 14px;
    color: #2d2e41;
    opacity: 30%;
    font-style: italic;
    font-weight: 500;
  }
`

interface TimePickerIProps {
  [key: string]: unknown
  isDisabled?: boolean
  onChange: (time: Date) => void
  time: Date
  timeZone?: string
}

export const TimePicker = ({
  isDisabled,
  time,
  timeZone,
  onChange,
  ...rest
}: TimePickerIProps) => {
  const removeUtcOffset = (date: Date) => {
    if (date) {
      const offset = new Date().getTimezoneOffset()
      date.setTime(date?.getTime() + offset * 60000)
      return date
    }
  }

  return (
    <StyledDatePicker
      {...rest}
      dateFormat='h:mm aa'
      disabled={isDisabled}
      onChange={onChange}
      onKeyDown={(event) => event.preventDefault()}
      placeholderText='Select end time'
      popperPlacement='bottom'
      selected={timeZone ? removeUtcOffset(time) : time}
      showTimeSelect
      showTimeSelectOnly
      timeCaption='Time'
      timeIntervals={TIME_INTERVAL}
    />
  )
}
